/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {KeyType} from '../models/KeyType';

export interface GenerateNewKey$Request {
    accountId: number;
    keyType: KeyType;
}

export interface GenerateNewKey$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const generateNewKeyRequest = createAction<PayloadData<void, GenerateNewKey$Request>>('KEY_CONTROLLER__GENERATE_NEW_KEY__REQUEST');
export const generateNewKeySuccess = createAction<PayloadData<void, GenerateNewKey$Request>>('KEY_CONTROLLER__GENERATE_NEW_KEY__SUCCESS');
export const generateNewKeyFailure = createAction<PayloadData<Error, GenerateNewKey$Request, true>>('KEY_CONTROLLER__GENERATE_NEW_KEY__FAILURE');

export const generateNewKeyActions = [
    generateNewKeyRequest,
    generateNewKeySuccess,
    generateNewKeyFailure
] as const;

/**
 * @param {number} meta.accountId Account id
 * @param {KeyType} meta.keyType Type of Key
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const generateNewKey = (meta: GenerateNewKey$Request, config?: GenerateNewKey$Config) => {
    const TRANSPORT_GET_PARAMS = {
        keyType: meta.keyType,
    };
    return {
        CALL_API: {
            types: generateNewKeyActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/new-key`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

